/** @jsxImportSource @emotion/react */

import { COLORS } from '@btime/constants'
import { css } from '@emotion/react'
// eslint-disable-next-line
import React from 'react'

import Icon from '../../shapes/Icon'
import Tag from '../Tag'

const DocumentThumb = ({ children, width, height, iconSize, extension }) => {
  const style = css`
    min-width: ${width || '100%'};
    min-height: ${height};
    max-width: 100%;
    max-height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    & .menuWrapper {
      position: absolute;
      right: 0;
      top: 0;
      margin: 0.4rem;
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;
    }

    & .content {
      padding: 2px;
      border-radius: 5px;
      background: #00000040;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    & .extension {
      position: absolute;
      bottom: 30%;
      left: 50%;
    }
  `

  return (
    <div className="documentThumb" css={style}>
      <div className="menuWrapper">{children && <div className="content">{children}</div>}</div>

      <Icon name="BsFileEarmarkText" size={iconSize || '4rem'} color={COLORS.dark3} />

      <div className="extension" color={COLORS.dark3}>
        <Tag label={extension} />
      </div>
    </div>
  )
}

export default DocumentThumb
